// extracted by mini-css-extract-plugin
export default {"container":"e1e31841aad4bf87"};